import React from 'react';
import { PlayerInfoProps } from '@screens/players/types/player.info.props';
import { InfoArea, InfoAreaTitle } from '@screens/players/player.details.tabs/player.info.styles';
import { StatsContainer } from '@screens/players/stats.container';
import { StatRow } from '@screens/players/stat.display';
import { formatDateFromMinutes } from '@domain/utils/format.utils';

export const DailyBonusInfo = ({ info }: PlayerInfoProps) => {
  const dailyBonus = info.detailBonus;
  if (!dailyBonus) return null;

  const minutes = dailyBonus.elapsedTimeMinutes;

  // eslint-disable-next-line no-nested-ternary
  const minutesFormatted = minutes !== null ? (minutes <= 0 ? 'READY' : formatDateFromMinutes(minutes)) : '';

  return (
    <InfoArea>
      <InfoAreaTitle>Daily Bonus</InfoAreaTitle>
      <StatsContainer outlined column expandHeight>
        <StatRow label='Bonus Sequence'>{dailyBonus.bonusSequence}</StatRow>
        <StatRow label='Day'>{dailyBonus.day}</StatRow>
        <StatRow label='Percents'>{dailyBonus.percents}</StatRow>
        <StatRow label='Next Collect'>{minutesFormatted}</StatRow>
      </StatsContainer>
    </InfoArea>
  );
};
